import React from 'react';
import './ValuePropositionComponent.css';
import '../../App.css'
import {Box, Flex, Image} from "@chakra-ui/react";
import InnerItemComponent from "./InnerItemComponent";
import {InnerItem} from "../../data/InnerItem";
import {useTranslation} from "react-i18next";


interface ValuePropositionComponentProps {
    content: InnerItem[],
    title: string,
    subTitle: string,
    image: string,
    imageForAnimation?: string,
    isProducer: boolean
}

const ValuePropositionComponent: React.FC<ValuePropositionComponentProps> = (props) => {
    const [t, i18n] = useTranslation('common');

    let animatedImage = props?.imageForAnimation != null ?
        <Image
            src={props.imageForAnimation} alt="Indie app" className="Actor-image" objectFit="contain"
        /> : null
    let imageComponent =
        <Flex width="100vw" className="producer-image-container">
            <div className="spacer"/>
            <Flex className="producer-image">
                <Image src={props.image} alt="Indie app" objectFit="contain"/>
                {animatedImage}
            </Flex>
            <div className="spacer"/>
        </Flex>

    let textComponent =
        <Flex width="100vw" justifyContent="center" alignItems="center">
        <Flex flexDirection="column"  className="value-proposition-description">
            <Box className="body-description-small" marginTop="24px">{t(props.title)}</Box>
            <span className="body-content-small-transparent">{t(props.subTitle)}</span>
            <Box marginTop="28px">
                {props.content.map((item) => {
                    return (
                        <InnerItemComponent itemData={item}/>
                    )
                })}
            </Box>
        </Flex>
        </Flex>

    let firstComponent = props?.isProducer ? imageComponent : textComponent
    let secondComponent = props?.isProducer ? textComponent : imageComponent

    return (
        <Flex className="tab-value-proposition">
            {firstComponent}
            {secondComponent}
        </Flex>
    )

}
export default ValuePropositionComponent